import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver/index.js';
import { BKJLoadingSpinner } from '../BKJLoadingSpinner/index.js';
import { mergeRefs } from '../BKJSelect/utils/mergeRefs.js';
import { InfiniteScrollLoadingWrapper } from './InfiniteScrollLoading.styled.js';
export const InfiniteScrollLoading = forwardRef((props, forwardedRef) => {
    const { onViewportEnter, id, ...rest } = props;
    const ref = useIntersectionObserver(onViewportEnter);
    return (_jsx(InfiniteScrollLoadingWrapper, { ...rest, id: String(id), ref: mergeRefs([ref, forwardedRef]), children: _jsx(BKJLoadingSpinner, { variant: "Small" }) }));
});
//# sourceMappingURL=InfiniteScrollLoading.js.map